module.exports = __webpack_public_path__ + "img/online-ship.4bb75352.svg";